var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"star-rating whitespace-no-wrap"},_vm._l((_vm.length),function(rating){return _c('label',{key:rating,staticClass:"star-rating__star",class:{
      'is-selected': _vm.value >= rating,
    }},[_vm._v(" ★ ")])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }